import {
  NBS_API_SEARCH_LOCATION_REQUEST,
  NBS_API_SEARCH_LOCATION_SUCCESS,
  NBS_API_SEARCH_LOCATION_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiSearchLocationRequest () {
  return { type: NBS_API_SEARCH_LOCATION_REQUEST };
}
function nbsApiSearchLocationSuccess (response) {
  return {
    type: NBS_API_SEARCH_LOCATION_SUCCESS,
    response
  };
}
function nbsApiSearchLocationError (error) {
  return {
    type: NBS_API_SEARCH_LOCATION_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiSearchLocation (data) {
  const url = 'searchLocation';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiSearchLocationRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiSearchLocationSuccess(response)))
      .catch(error => dispatch(nbsApiSearchLocationError(error)));
  };
}
